<template>
    <div id="app" :style="{ '--theme-color': themeColor }">
        <v-header></v-header>
        <v-logo></v-logo>
        <v-nav></v-nav>
        <v-breadcrumb></v-breadcrumb>
        <router-view class="router-view"></router-view>
        <v-footer></v-footer>

        <!-- 右侧栏 -->
        <div class="fixed">
            <div class="item" @click="toPage('/shopCart')">
                <img src="./assets/home-01.png" alt />
            </div>
            <div class="item" @click="toQQ" v-if="qq">
                <img src="./assets/home-02.png" alt />
            </div>
            <div class="item" @click="toPage('/center/order')">
                <img src="./assets/home-03.png" alt />
            </div>
            <div class="item" @click="toTop">
                <img style="width:30px;height:30px" src="./assets/home-06.png" alt />
            </div>
        </div>
    </div>
</template>

<script>
import Header from './components/Header';
import Footer from './components/Footer';
import Logo from './components/Logo';
import Nav from './components/Nav';
import Breadcrumb from './components/Breadcrumb';

import { mapActions } from 'vuex';

import * as apis from '@/fetch/common';

export default {
    data() {
        return {
            qq: '',
            themeColor: '',
        };
    },
    name: 'app',
    components: {
        'v-header': Header,
        'v-footer': Footer,
        'v-logo': Logo,
        'v-nav': Nav,
        'v-breadcrumb': Breadcrumb,
    },
    methods: {
        ...mapActions(['setBreadcrumb', 'setWebBaseInfo']),
        toPage(page) {
            this.$router.push(page);
        },
        toQQ() {
            const url = `http://wpa.qq.com/msgrd?v=3&uin=${this.qq}&site=qq&menu=yes`;
            window.open(url);
        },
        toTop() {
            window.scrollTo(0, 0);
        },
    },
    created() {
        this.$router.beforeEach((to, from, next) => {
            window.scrollTo(0, 0);
            next();
        });

        // 获取网站基本信息
        apis.querySettingSimpleList().then(res => {
            let obj = res.data.find(r => r.code === 'baseInfo');
            let formateObj = JSON.parse(obj.value);
            this.setWebBaseInfo(formateObj);
            this.qq = formateObj.qq || '';
            this.themeColor = formateObj.themeColor || '#e3150a';
            document.title = `${formateObj.siteName}`;
        });
    },
};
</script>

<style lang="less" scoped>
.fixed {
    width: 50px;
    position: fixed;
    top: 120px;
    right: 0px;
    z-index: 99;
    .item {
        width: 50px;
        height: 50px;
        margin-bottom: 5px;
        cursor: pointer;
        position: relative;
        background: #d3c2c2;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            width: 35px;
            height: 35px;
        }
    }
    .qr {
        &:hover {
            .qr-code {
                display: block;
            }
        }
        .qr-code {
            width: 150px;
            height: 150px;
            background-color: #fff;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            position: absolute;
            top: -50px;
            right: 70px;
            border-radius: 6px;
            padding: 5px;
            display: none;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .qr-code::after {
            content: '';
            position: absolute;
            border-left: 10px solid #fff;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            top: 68px;
            right: -10px;
        }
    }
}
</style>
<style lang="less">
html,
body {
    padding: 0;
    margin: 0;
    background-color: #f4f5fa;
}

* {
    margin: 0;
    padding: 0;
}

a {
    text-decoration: none;
}

.container {
    width: 1160px;
    margin: 0 auto;

    .el-button--success,
    .el-button--success:focus,
    .el-button--success:hover,
    .el-button--primary,
    .el-button--primary:focus,
    .el-button--primary:hover {
        background-color: var(--theme-color);
        border-color: var(--theme-color);
    }
}

.router-view {
    min-height: 100px;
    margin-bottom: 20px;
}

table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    text-align: center;
    font-size: 13px;
}

table .th {
    height: 40px;
    line-height: 40px;
    color: #fff;
    font-size: 14px;
    margin-bottom: 23px;
    background-color: var(--theme-color);
}

table tr {
    height: 45px;
    margin-top: 10px;
    // background-color: #fff;
}

table .tr:hover {
    background-color: #d4cdcd;
}

table td {
    padding: 0 2px;
}

.pagination {
    margin-top: 30px;
    text-align: center;
    .el-pagination.is-background .el-pager {
        li:not(.disabled).active {
            background-color: var(--theme-color);
        }
        li:not(.disabled):hover {
            color: var(--theme-color);
        }
    }
}

.table-empty {
    width: 100%;
    margin: 50px auto;
    text-align: center;
    color: #999;
    padding-bottom: 10px;
    i {
        font-size: 60px;
    }
    p {
        font-size: 12px;
    }
}

.el-select {
    width: 100%;
}
.el-dialog__body {
    padding: 15px 20px;
}
</style>
